// TennisTrack Hub — Form Nuovo Allenamento (Tennis + Fitness) | 029 Project
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';
import Navbar from '../../components/Navbar';
import './Allenamenti.css';

const COLPI_TENNIS = [
  'Servizio', 'Dritto', 'Rovescio', 'Volée di dritto', 'Volée di rovescio',
  'Smash', 'Lob', 'Slice', 'Kick', 'Drop shot', 'Risposta', 'Gioco di gambe'
];

// ── Modal selezione template ─────────────────────────────────
const ModalTemplate = ({ tipo, piano, onSeleziona, onChiudi }) => {
  const [sezione, setSezione] = useState('miei');
  const [templateMiei, setTemplateMiei] = useState([]);
  const [templateServer, setTemplateServer] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cerca, setCerca] = useState('');

  const carica = useCallback(async () => {
    setLoading(true);
    try {
      const [rMiei, rServer] = await Promise.all([
        api.get('/template/miei'),
        api.get('/template/server', { params: { tipo } })
      ]);
      setTemplateMiei(rMiei.data.template);
      setTemplateServer(rServer.data.template);
    } catch { /* silenzioso */ }
    finally { setLoading(false); }
  }, [tipo]);

  useEffect(() => { carica(); }, [carica]);

  const filtra = (lista) => {
    if (!cerca.trim()) return lista;
    return lista.filter(t =>
      t.titolo.toLowerCase().includes(cerca.toLowerCase()) ||
      (t.descrizione || '').toLowerCase().includes(cerca.toLowerCase())
    );
  };

  const lista = filtra(sezione === 'miei' ? templateMiei : templateServer);

  const pianoBadge = (p) => {
    if (p === 'pro') return <span style={{ fontSize: '0.7rem', background: '#f0a500', color: '#000', borderRadius: '4px', padding: '1px 5px', marginLeft: '6px' }}>⭐ PRO</span>;
    if (p === 'demo') return <span style={{ fontSize: '0.7rem', background: '#6c757d', color: '#fff', borderRadius: '4px', padding: '1px 5px', marginLeft: '6px' }}>DEMO</span>;
    return null;
  };

  return (
    <div className="modal-overlay" onClick={onChiudi}>
      <div className="modal-box" style={{ maxWidth: '680px', width: '95%', maxHeight: '80vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h3 style={{ margin: 0 }}>📋 Seleziona Template</h3>
          <button className="btn btn-secondary btn-sm" onClick={onChiudi}>✕</button>
        </div>

        {/* Cerca */}
        <input
          type="text"
          placeholder="🔍 Cerca template..."
          value={cerca}
          onChange={e => setCerca(e.target.value)}
          style={{ marginBottom: '12px', padding: '8px 12px', borderRadius: '8px', border: '1px solid var(--border-color)', background: 'var(--bg-input)', color: 'var(--text-primary)', width: '100%', boxSizing: 'border-box' }}
        />

        {/* Tab */}
        <div className="tab-bar" style={{ marginBottom: '12px' }}>
          <button className={`tab-btn ${sezione === 'miei' ? 'active' : ''}`} onClick={() => setSezione('miei')}>
            🗂 I miei ({templateMiei.length})
          </button>
          <button className={`tab-btn ${sezione === 'esplora' ? 'active' : ''}`} onClick={() => setSezione('esplora')}>
            🌐 Libreria ({templateServer.filter(t => !t.bloccato).length})
          </button>
        </div>

        {/* Lista */}
        <div style={{ overflowY: 'auto', flex: 1 }}>
          {loading ? (
            <div className="loading-msg">Caricamento...</div>
          ) : lista.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '32px', color: 'var(--text-secondary)' }}>
              {cerca ? 'Nessun risultato.' : 'Nessun template disponibile.'}
            </div>
          ) : (
            lista.map(t => {
              const bloccato = t.bloccato === true;
              return (
                <div
                  key={t.id}
                  onClick={() => !bloccato && onSeleziona(t)}
                  style={{
                    padding: '12px 14px',
                    marginBottom: '8px',
                    borderRadius: '8px',
                    border: '1px solid var(--border-color)',
                    background: bloccato ? 'rgba(255,255,255,0.03)' : 'var(--bg-card)',
                    cursor: bloccato ? 'not-allowed' : 'pointer',
                    opacity: bloccato ? 0.5 : 1,
                    transition: 'border-color 0.15s'
                  }}
                  onMouseEnter={e => { if (!bloccato) e.currentTarget.style.borderColor = 'var(--color-primary)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border-color)'; }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                    <strong style={{ color: 'var(--text-primary)', fontSize: '0.95rem' }}>
                      {t.tipo === 'tennis' ? '🎾' : '💪'} {t.titolo}
                    </strong>
                    {pianoBadge(t.piano)}
                    {bloccato && <span style={{ marginLeft: '8px', fontSize: '0.75rem', color: 'var(--color-error)' }}>🔒 Pro</span>}
                  </div>
                  {t.descrizione && (
                    <p style={{ margin: 0, fontSize: '0.82rem', color: 'var(--text-secondary)', lineHeight: 1.4 }}>
                      {t.descrizione.length > 100 ? t.descrizione.substring(0, 100) + '…' : t.descrizione}
                    </p>
                  )}
                  <div style={{ marginTop: '6px', fontSize: '0.75rem', color: 'var(--text-secondary)', display: 'flex', gap: '12px' }}>
                    {t.livello && <span>📊 {t.livello}</span>}
                    {t.categoria && <span>🏷 {t.categoria}</span>}
                    {sezione === 'esplora' && t.n_utilizzi > 0 && <span>📥 {t.n_utilizzi} utilizzi</span>}
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

// ── Componente principale ────────────────────────────────────
const FormAllenamento = () => {
  const navigate = useNavigate();
  const { atletaId } = useParams();
  const location = useLocation();
  const { utente } = useAuth();
  const tipoDefault = new URLSearchParams(location.search).get('tipo') || 'tennis';

  const [atleta, setAtleta] = useState(null);
  const [tipo, setTipo] = useState(tipoDefault);
  const [form, setForm] = useState({
    data: new Date().toISOString().split('T')[0],
    valutazione: 0,
    obiettivi: '',
    note: ''
  });
  const [esercizi, setEsercizi] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errore, setErrore] = useState('');
  const [mostraModalTemplate, setMostraModalTemplate] = useState(false);

  useEffect(() => {
    api.get(`/atleti/${atletaId}`)
      .then(res => setAtleta(res.data.atleta))
      .catch(() => navigate('/atleti'));
  }, [atletaId, navigate]);

  // ── Carica template nel form ──────────────────────────────
  const caricaTemplate = (template) => {
    setMostraModalTemplate(false);
    const contenuto = template.contenuto;
    if (!contenuto) return;

    // Supporta sia array diretto che oggetto con chiave "esercizi" o "sezioni"
    let esercizi_raw = [];
    if (Array.isArray(contenuto)) {
      esercizi_raw = contenuto;
    } else if (contenuto.esercizi && Array.isArray(contenuto.esercizi)) {
      esercizi_raw = contenuto.esercizi;
    } else if (contenuto.sezioni && Array.isArray(contenuto.sezioni)) {
      // Formato avanzato con sezioni — appiattisce tutti gli esercizi
      esercizi_raw = contenuto.sezioni.flatMap(s => s.esercizi || []);
    }

    if (esercizi_raw.length === 0) return;

    if (tipo === 'tennis') {
      const nuovi = esercizi_raw.map(e => ({
        colpo: COLPI_TENNIS.includes(e.colpo) ? e.colpo : (COLPI_TENNIS.find(c => c.toLowerCase().includes((e.colpo || '').toLowerCase())) || COLPI_TENNIS[0]),
        difficolta: e.difficolta || 5,
        descrizione: e.descrizione || e.istruzioni || e.nome || ''
      }));
      setEsercizi(nuovi);
    } else {
      const nuovi = esercizi_raw.map(e => ({
        nome: e.nome || e.colpo || '',
        tipologia: 'corpo_intero',
        serie: e.serie || '',
        ripetizioni: e.reps || e.ripetizioni || '',
        caricoKg: '',
        note: e.descrizione || e.istruzioni || e.note || ''
      }));
      setEsercizi(nuovi);
    }

    // Imposta obiettivi dal template se vuoti
    if (!form.obiettivi && template.titolo) {
      setForm(f => ({ ...f, obiettivi: template.titolo }));
    }
  };

  // ── Gestione esercizi tennis ──────────────────────────────
  const aggiungiEsercizioTennis = () => {
    setEsercizi([...esercizi, { colpo: COLPI_TENNIS[0], difficolta: 5, descrizione: '' }]);
  };

  const aggiungiEsercizioFitness = () => {
    setEsercizi([...esercizi, { nome: '', tipologia: 'corpo_intero', serie: '', ripetizioni: '', caricoKg: '', note: '' }]);
  };

  const aggiornaEsercizio = (index, campo, valore) => {
    const nuovi = [...esercizi];
    nuovi[index] = { ...nuovi[index], [campo]: valore };
    setEsercizi(nuovi);
  };

  const rimuoviEsercizio = (index) => {
    setEsercizi(esercizi.filter((_, i) => i !== index));
  };

  const cambiaTipo = (nuovoTipo) => {
    setTipo(nuovoTipo);
    setEsercizi([]);
  };

  // ── Submit ────────────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (esercizi.length === 0) return setErrore('Aggiungi almeno un esercizio.');
    if (tipo === 'tennis' && esercizi.some(e => !e.colpo)) return setErrore('Tutti gli esercizi devono avere un colpo.');
    if (tipo === 'fitness' && esercizi.some(e => !e.nome.trim())) return setErrore('Tutti gli esercizi devono avere un nome.');

    setLoading(true);
    setErrore('');
    try {
      const res = await api.post('/allenamenti', {
        atletaId: parseInt(atletaId),
        tipo,
        ...form,
        valutazione: form.valutazione || null,
        esercizi
      });
      navigate(`/allenamenti/${res.data.allenamento.id}`);
    } catch (err) {
      setErrore(err.response?.data?.error || 'Errore durante il salvataggio.');
    } finally {
      setLoading(false);
    }
  };

  if (!atleta) return <div className="page-layout"><Navbar /><div className="loading-msg">Caricamento...</div></div>;

  return (
    <div className="page-layout">
      <Navbar />
      <main className="page-main">

        <div className="page-header">
          <div>
            <h1>Nuovo Allenamento</h1>
            <p>Atleta: <strong>{atleta.nome} {atleta.cognome}</strong></p>
          </div>
          <button className="btn btn-secondary" onClick={() => navigate(`/atleti/${atletaId}`)}>
            ← Indietro
          </button>
        </div>

        {errore && <div className="alert alert-error">{errore}</div>}

        {/* Selector tipo */}
        <div className="tipo-selector">
          <button
            type="button"
            className={`tipo-btn ${tipo === 'tennis' ? 'active' : ''}`}
            onClick={() => cambiaTipo('tennis')}
          >
            🎾 Allenamento Tennis
          </button>
          <button
            type="button"
            className={`tipo-btn ${tipo === 'fitness' ? 'active' : ''}`}
            onClick={() => cambiaTipo('fitness')}
          >
            💪 Allenamento Fitness
          </button>
        </div>

        <form onSubmit={handleSubmit}>

          {/* Info generali */}
          <div className="card form-section">
            <h3 className="section-title">📋 Info generali</h3>
            <div className="form-row">
              <div className="form-group">
                <label>Data *</label>
                <input
                  type="date"
                  value={form.data}
                  onChange={e => setForm({ ...form, data: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>Valutazione sessione</label>
                <div className="stelle-selector">
                  {[1, 2, 3, 4, 5].map(n => (
                    <button
                      key={n}
                      type="button"
                      className={`stella ${form.valutazione >= n ? 'attiva' : ''}`}
                      onClick={() => setForm({ ...form, valutazione: form.valutazione === n ? 0 : n })}
                    >★</button>
                  ))}
                  {form.valutazione > 0 && (
                    <span className="stelle-label">{form.valutazione}/5</span>
                  )}
                </div>
              </div>
            </div>
            <div className="form-group">
              <label>Obiettivi della sessione</label>
              <input
                type="text"
                placeholder="es. Migliorare il servizio slice..."
                value={form.obiettivi}
                onChange={e => setForm({ ...form, obiettivi: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>Note generali</label>
              <textarea
                rows={2}
                placeholder="Osservazioni generali sulla sessione..."
                value={form.note}
                onChange={e => setForm({ ...form, note: e.target.value })}
              />
            </div>
          </div>

          {/* Esercizi Tennis */}
          {tipo === 'tennis' && (
            <div className="card form-section">
              <div className="section-header-inline">
                <h3 className="section-title">🎾 Esercizi Tennis</h3>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={() => setMostraModalTemplate(true)}
                    title="Importa esercizi da un template"
                  >
                    📋 Carica template
                  </button>
                  <button type="button" className="btn btn-secondary btn-sm" onClick={aggiungiEsercizioTennis}>
                    + Aggiungi esercizio
                  </button>
                </div>
              </div>

              {esercizi.length === 0 && (
                <div className="esercizi-vuoti">
                  <p>Nessun esercizio aggiunto.</p>
                  <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', marginTop: '8px' }}>
                    <button type="button" className="btn btn-primary btn-sm" onClick={() => setMostraModalTemplate(true)}>
                      📋 Carica da template
                    </button>
                    <button type="button" className="btn btn-secondary btn-sm" onClick={aggiungiEsercizioTennis}>
                      + Aggiungi manualmente
                    </button>
                  </div>
                </div>
              )}

              {esercizi.map((es, i) => (
                <div key={i} className="esercizio-card">
                  <div className="esercizio-header">
                    <span className="esercizio-num">#{i + 1}</span>
                    <button type="button" className="btn-rimuovi" onClick={() => rimuoviEsercizio(i)}>✕</button>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Colpo</label>
                      <select
                        value={es.colpo}
                        onChange={e => aggiornaEsercizio(i, 'colpo', e.target.value)}
                      >
                        {COLPI_TENNIS.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Difficoltà (1–10)</label>
                      <div className="difficolta-slider">
                        <input
                          type="range"
                          min="1" max="10"
                          value={es.difficolta || 5}
                          onChange={e => aggiornaEsercizio(i, 'difficolta', parseInt(e.target.value))}
                        />
                        <span className="difficolta-val">{es.difficolta || 5}</span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Descrizione esercizio</label>
                    <textarea
                      rows={2}
                      placeholder="Descrivi l'esercizio, variazioni, punti chiave..."
                      value={es.descrizione}
                      onChange={e => aggiornaEsercizio(i, 'descrizione', e.target.value)}
                    />
                  </div>
                </div>
              ))}

              {esercizi.length > 0 && (
                <div style={{ marginTop: '8px', display: 'flex', gap: '8px' }}>
                  <button type="button" className="btn btn-secondary btn-sm" onClick={() => setMostraModalTemplate(true)}>
                    📋 Sostituisci con template
                  </button>
                  <button type="button" className="btn btn-secondary btn-sm" onClick={aggiungiEsercizioTennis}>
                    + Aggiungi esercizio
                  </button>
                </div>
              )}
            </div>
          )}

          {/* Esercizi Fitness */}
          {tipo === 'fitness' && (
            <div className="card form-section">
              <div className="section-header-inline">
                <h3 className="section-title">💪 Esercizi Fitness</h3>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={() => setMostraModalTemplate(true)}
                    title="Importa esercizi da un template"
                  >
                    📋 Carica template
                  </button>
                  <button type="button" className="btn btn-secondary btn-sm" onClick={aggiungiEsercizioFitness}>
                    + Aggiungi esercizio
                  </button>
                </div>
              </div>

              {esercizi.length === 0 && (
                <div className="esercizi-vuoti">
                  <p>Nessun esercizio aggiunto.</p>
                  <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', marginTop: '8px' }}>
                    <button type="button" className="btn btn-primary btn-sm" onClick={() => setMostraModalTemplate(true)}>
                      📋 Carica da template
                    </button>
                    <button type="button" className="btn btn-secondary btn-sm" onClick={aggiungiEsercizioFitness}>
                      + Aggiungi manualmente
                    </button>
                  </div>
                </div>
              )}

              {esercizi.map((es, i) => (
                <div key={i} className="esercizio-card">
                  <div className="esercizio-header">
                    <span className="esercizio-num">#{i + 1}</span>
                    <button type="button" className="btn-rimuovi" onClick={() => rimuoviEsercizio(i)}>✕</button>
                  </div>
                  <div className="form-row">
                    <div className="form-group" style={{ flex: 2 }}>
                      <label>Nome esercizio *</label>
                      <input
                        type="text"
                        placeholder="es. Squat, Panca piana, Affondi..."
                        value={es.nome}
                        onChange={e => aggiornaEsercizio(i, 'nome', e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Tipologia</label>
                      <select
                        value={es.tipologia}
                        onChange={e => aggiornaEsercizio(i, 'tipologia', e.target.value)}
                      >
                        <option value="superiore">Superiore</option>
                        <option value="inferiore">Inferiore</option>
                        <option value="corpo_intero">Corpo intero</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-row form-row-3">
                    <div className="form-group">
                      <label>Serie</label>
                      <input type="number" min="1" max="20" placeholder="3"
                        value={es.serie}
                        onChange={e => aggiornaEsercizio(i, 'serie', e.target.value)} />
                    </div>
                    <div className="form-group">
                      <label>Ripetizioni</label>
                      <input type="number" min="1" max="100" placeholder="12"
                        value={es.ripetizioni}
                        onChange={e => aggiornaEsercizio(i, 'ripetizioni', e.target.value)} />
                    </div>
                    <div className="form-group">
                      <label>Carico (kg)</label>
                      <input type="number" min="0" max="500" step="0.5" placeholder="60"
                        value={es.caricoKg}
                        onChange={e => aggiornaEsercizio(i, 'caricoKg', e.target.value)} />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Note esercizio</label>
                    <input type="text" placeholder="es. Pausa 90s tra le serie..."
                      value={es.note}
                      onChange={e => aggiornaEsercizio(i, 'note', e.target.value)} />
                  </div>
                </div>
              ))}

              {esercizi.length > 0 && (
                <div style={{ marginTop: '8px', display: 'flex', gap: '8px' }}>
                  <button type="button" className="btn btn-secondary btn-sm" onClick={() => setMostraModalTemplate(true)}>
                    📋 Sostituisci con template
                  </button>
                  <button type="button" className="btn btn-secondary btn-sm" onClick={aggiungiEsercizioFitness}>
                    + Aggiungi esercizio
                  </button>
                </div>
              )}
            </div>
          )}

          {/* Azioni */}
          <div className="form-actions form-actions-bottom">
            <button type="button" className="btn btn-secondary" onClick={() => navigate(`/atleti/${atletaId}`)}>
              Annulla
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Salvataggio...' : '💾 Salva allenamento'}
            </button>
          </div>
        </form>

      </main>

      {/* Modal template */}
      {mostraModalTemplate && (
        <ModalTemplate
          tipo={tipo}
          piano={utente?.piano || 'free'}
          onSeleziona={caricaTemplate}
          onChiudi={() => setMostraModalTemplate(false)}
        />
      )}

    </div>
  );
};

export default FormAllenamento;
